import React from "react";
import { ColumnProps } from "antd/lib/table";
import { SerializedEntity } from "@cuba-platform/rest";
import { NotPersisitBprocActors } from "../../../cuba/entities/base/tsadv_NotPersisitBprocActors";
import { TableAdaptive } from "../../common";

type ApproverTableProps = {
  items: NotPersisitBprocActors[];
  columns: ColumnProps<SerializedEntity<NotPersisitBprocActors>>[];
  loading?: boolean;
};

export const ApproverTable = ({
  items,
  columns,
  loading,
}: ApproverTableProps) => {
  if (!loading && (!items || items.length === 0)) return null;

  return (
    <>
      <TableAdaptive<NotPersisitBprocActors>
        dataSource={Array.from(items || [])}
        rowKey={"id"}
        isNeedMobile
        pagination={false}
        loading={loading}
        columns={columns}
      />
    </>
  );
};
